__turbopack_context__.v({
  "active": "GR0pkq_active",
  "checked": "GR0pkq_checked",
  "indicator": "GR0pkq_indicator",
  "root": "GR0pkq_root",
  "segment": "GR0pkq_segment",
});
